import {
  createStopVideoDeleteRequest,
  createVideoDelete,
  deleteVideoDelete,
  getVideoDelete,
  updateVideoDelete,
} from 'lib/api';
import { CreateParams, QueryParams, VIDEO_DELETES_ACTIONS } from '.';

const {
  GET_VIDEO_DELETES_START,
  GET_VIDEO_DELETES_ERROR,
  GET_VIDEO_DELETES_SUCCESS,
  ADD_VIDEO_DELETES_START,
  ADD_VIDEO_DELETES_ERROR,
  ADD_VIDEO_DELETES_SUCCESS,
  EDIT_VIDEO_DELETES_START,
  EDIT_VIDEO_DELETES_ERROR,
  EDIT_VIDEO_DELETES_SUCCESS,
  DELETE_VIDEO_DELETES_START,
  DELETE_VIDEO_DELETES_ERROR,
  DELETE_VIDEO_DELETES_SUCCESS,
  ADD_STOP_VIDEO_DELETES_START,
  ADD_STOP_VIDEO_DELETES_ERROR,
  ADD_STOP_VIDEO_DELETES_SUCCESS,
} = VIDEO_DELETES_ACTIONS;

export const loadVideoDelete = async ({
  dispatch,
}: QueryParams): Promise<void> => {
  dispatch({ type: GET_VIDEO_DELETES_START });

  const response = await getVideoDelete().catch((err: any) => err);
  if (response instanceof Error) {
    dispatch({
      type: GET_VIDEO_DELETES_ERROR,
      error: response.message,
    });
    return;
  }
  const payload = response;
  dispatch({ type: GET_VIDEO_DELETES_SUCCESS, payload });
};

export const addVideoDelete = async ({
  data,
  dispatch,
}: CreateParams): Promise<void> => {
  dispatch({ type: ADD_VIDEO_DELETES_START });

  const videoDelete = await createVideoDelete({ data }).catch(
    (err: any) => err
  );
  if (videoDelete instanceof Error) {
    dispatch({
      type: ADD_VIDEO_DELETES_ERROR,
      error: videoDelete.message,
    });
    return;
  }
  const payload = {
    videoDelete,
  };
  dispatch({ type: ADD_VIDEO_DELETES_SUCCESS, payload });
};

export const editVideoDelete = async (params: any): Promise<void> => {
  const { data, dispatch } = params;
  dispatch({ type: EDIT_VIDEO_DELETES_START });

  const videoDelete = await updateVideoDelete(data).catch((err: any) => err);
  if (videoDelete instanceof Error) {
    dispatch({
      type: EDIT_VIDEO_DELETES_ERROR,
      error: videoDelete.message,
    });
    return;
  }
  const payload = {
    videoDelete,
  };
  dispatch({ type: EDIT_VIDEO_DELETES_SUCCESS, payload });
};

export const removeVideoDelete = async ({
  data,
  dispatch,
}: CreateParams): Promise<void> => {
  dispatch({ type: DELETE_VIDEO_DELETES_START });

  const videoDelete = await deleteVideoDelete(data.deleteId).catch(
    (err: any) => err
  );
  if (videoDelete instanceof Error) {
    dispatch({
      type: DELETE_VIDEO_DELETES_ERROR,
      error: videoDelete.message,
    });
    return;
  }
  const payload = {
    videoDelete: data,
  };
  dispatch({ type: DELETE_VIDEO_DELETES_SUCCESS, payload });
};

export const addStopVideoDeleteRequest = async ({
  data,
  dispatch,
}: CreateParams): Promise<void> => {
  dispatch({ type: ADD_STOP_VIDEO_DELETES_START });

  const stopVideoDeleteRequest = await createStopVideoDeleteRequest({
    data,
  }).catch((err: any) => err);
  if (stopVideoDeleteRequest instanceof Error) {
    dispatch({
      type: ADD_STOP_VIDEO_DELETES_ERROR,
      error: stopVideoDeleteRequest.message,
    });
    return;
  }
  const payload = {
    stopVideoDeleteRequest,
  };
  dispatch({ type: ADD_STOP_VIDEO_DELETES_SUCCESS, payload });
};
